export function changeLanguage(lang) {
  return localStorage.setItem('lang', lang);
}

export function getLanguage() {
  return localStorage.getItem('lang');
}